<template>
  <el-dialog :title="'录入打印数据'" :visible="visible">
    <el-form label-width="60px" :model="editForm" :rules="rules" ref="editForm">
      <el-form-item label="型号" prop="model_type">
        <el-input
          size="small"
          v-model="editForm.model_type"
          auto-complete="off"
          placeholder="请输入型号"
        ></el-input>
      </el-form-item>

      <el-form-item label="客户" prop="customer">
        <el-input
          size="small"
          v-model="editForm.customer"
          auto-complete="off"
          placeholder="请输入客户名称"
        ></el-input>
      </el-form-item>

      <el-form-item label="数量" prop="quantity">
        <el-input
          size="small"
          v-model="editForm.quantity"
          auto-complete="off"
          placeholder="请输入生产数量"
          type="number"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="生产日期" prop="date">
        <el-date-picker v-model="editForm.date" type="date" placeholder="选择日期">
        </el-date-picker>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">取消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        class="title"
        @click="submitForm"
        >打印预览</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      editForm: {},
      visible:true,
     loading:false,
     rules:{
       customer:{required: true, message: '请输入型号', trigger: 'blur' },
       model_type:{required: true, message: '请输入型号', trigger: 'blur' },
       quantity:{required: true, message: '请输入数量', trigger: 'blur' },
          }
    };
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    submitForm() {
      this.$refs['editForm'].validate((res)=>{
        if(res){
          this.$emit("save", this.editForm);
        }
      })
      
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/printerManage/pop/addRecord.vue